
import "../../grower/personalDetails/personalDetails.css";
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import resolveIcon from "../../../../../images/resolved.png";
import { UPLOAD_DCUMENT, GET_ADDRESS_BY_IFSC, authKey, ResourceUpdateMember } from "../../../../../common/URLs";

import { Button, Switch, FormGroup, FormControlLabel, Stack, Box, Typography, Grid, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField, FormLabel, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { ROLES, BLOCK_LIST, CONSTANTS, LAND_AREA_UNIT, REVENUE_CIRCLE, INVALID_OTP_ERROR } from "../../../../../common/constants";
import { nameValidation, typeNumberValid, VALIDATION, landAreaValidation, openTextFieldMaxLength, emailValidation, maxNameLength, mobileNoMaxLength, emailUrnPassMaxLength, addressMaxLength, govtIDcardLength, approverCommentMaxLength } from "../../../../../common/commonValidations";
import { sendOTP, validateOTP } from '../../../../../common/Utils';
import { GENDER, SALUTATION } from '../../../../../common/constants';
import { BASIC_DATE_FORMAT, API_DATE_FORMAT } from '../../../../../common/constants';
import moment from 'moment';
import jwt from 'jwt-decode';
import { FileUploadMUI } from "../../../../../common/fileUpload/fileUploadMUI";
import { getLocalStorageItem } from "../../../../../common/localStorageUtils";
import { LAND_AREA_ERROR } from "../../../../../common/constants";
import { CommonPincodeMUI } from '../../../../../common/common-pincode/commonPincodeMUI';
import InputAdornment from '@mui/material/InputAdornment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { useTranslation } from "react-i18next";
import { useGrowerIndividulalContextData } from "../../registrationDetails";
import { CheckCircle as TickIcon, Search as SearchIcon, Add as AddIcon, Cancel as CrossIcon, ArrowForwardIosSharp as AccordionIcon } from '@mui/icons-material';
import { DataGrid } from '@mui/x-data-grid';
import AccordionDetails from '@mui/material/AccordionDetails';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import { toast } from 'react-toastify';
import { insertComment } from '../../commonRegistrationStakeholderAPIs';
import Badge from 'react-bootstrap/Badge';
import { handleNumberFieldFocus } from "../../../../../common/commonFunction";
import { SaveIcon } from "../../../../../common/icons";
import BadgeComponent from "../../../../../common/badge";
import apiClient from "../../../../../axios";
import CommentIcon from '@mui/icons-material/Comment';


const JFMCGovtPersonalDetails = ({ updatePersonalCallback }) => {
  const { viewOnly, growerDetails, personalDetailsSectionOk, setPersonalDetailsSectionOk, bankDetailsSectionOk, setBankDetailsSectionOk, agreementDetailsSectionOk, setAgreementDetailsSectionOk, shouldActOnSection, showWorkFlowButtons, enableSaveSubmitButtons, showCommentSection, setCommentsData, comments, setComments, enableFieldFunction, expandedSection, setExpandedSection, personalUpdatedDetails, setPersonalUpdatedDetails, errorMessage, setErrorMessage, regScruResourceUpdate, setRegScruResourceUpdate } = useGrowerIndividulalContextData();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const [landAreaValue, setLandAreaValue] = useState('');
  const [landAreaUnit, setLandAreaUnit] = useState(LAND_AREA_UNIT[0]);
  const [characterLimit] = useState(300);
  let personalComments = comments?.filter((item) => item.sectionName === "personal_details");
  let bankComments = comments?.filter((item) => item.sectionName === "bank_details");
  // let bambooComments = comments?.filter((item) => item.sectionName === "bamboo_details");
  let agreementComments = comments?.filter((item) => item.sectionName === "agreement_details");
  const [personalComment, setPersonalComment] = useState("");
  const [bankComment, setBankComment] = useState("");
  // const [bambooComment, setBambooComment] = useState("");
  const [agreementComment, setAgreementComment] = useState("");
  const uuid = localStorage.getItem('uuid');
  // let regStakeholderMaster = growerDetails?.growers[0]?.regStakeholderMaster;
  const [mobileOTPValidated, setMobileOTPValidated] = useState(false);
  const [agreementStartDateDisplay, setAgreementStartDateDisplay] = useState();
  const [agreementEndDateDisplay, setAgreementEndDateDisplay] = useState();
  const [bankDetails, setBankDetails] = useState();
  const [otpValue, setOtpValue] = useState()
  const [otpHidden, setOtpHidden] = useState(true);
  const [verifyMobileNo, setVerifyMobileNo] = useState(false);
  const decoded = jwt(getLocalStorageItem('id_token'));
  const [isMSMERadio, setIsMSMERadio] = useState('NO');

  let userRole = localStorage.getItem('role');

  useEffect(() => {
    if (growerDetails) {
      setIsMSMERadio(
        personalUpdatedDetails?.isMSME === 1 ? 'YES' : 'NO'
      );
    }
  }, [personalUpdatedDetails]);

  useEffect(() => {
    setPersonalUpdatedDetails(prev => ({
      ...prev,
      isMSME: isMSMERadio === 'YES' ? 1 : 0,
      msmeCategory: isMSMERadio === 'NO' ? '' : prev.msmeCategory
    }));
  }, [isMSMERadio]);

  const MSME_CATEGORY_OPTIONS = [
    { key: "MSM1", description: "Micro:Goods Mnfg/Spl" },
    { key: "MSM2", description: "Micro:Service Provdr" },
    { key: "MSM3", description: "Small:Goods Mnfg/Spl" },
    { key: "MSM4", description: "Small:Service Provdr" },
    { key: "MSM5", description: "Medium:Good Mnfg/Spl" },
    { key: "MSM6", description: "Medium:Service Provdr" },
    { key: "MSM7", description: "Other:Goods Mnfg/Spl" },
    { key: "MSM8", description: "Other:Service Provdr" },
    { key: "OTHER", description: "Others" }
  ];

  useEffect(() => {
    if (growerDetails) {
      const regStakeholderMaster =
        growerDetails?.growers[0]?.regStakeholderMaster;

      setPersonalUpdatedDetails({
        ...personalUpdatedDetails,
        fullName: regStakeholderMaster?.name,
        contactPersonSalutation: regStakeholderMaster?.contactPersonSalutation,
        contactPersonGender: regStakeholderMaster?.contactPersonGender,
        contactPersonFirstname: regStakeholderMaster?.contactPersonFirstname,
        contactPersonMiddlename: regStakeholderMaster?.contactPersonMiddlename,
        contactPersonLastname: regStakeholderMaster?.contactPersonLastname,
        emailId: regStakeholderMaster?.emailId,
        address: growerDetails?.growers[0]?.address,
        pincode: growerDetails?.growers[0]?.pincode,
        state: growerDetails?.growers[0]?.state,
        district: growerDetails?.growers[0]?.district,
        revenueCircle: growerDetails?.growers[0]?.revenueCircle,
        blockName: growerDetails?.growers[0]?.blockName,
        mobileNo: regStakeholderMaster?.mobileNo,
        govtIdCardType: regStakeholderMaster?.govtIdCardType ? regStakeholderMaster?.govtIdCardType : CONSTANTS.ID_PROOF_ARRAY[0],
        govtIdCardNumber: regStakeholderMaster?.govtIdCardNumber,
        panNumber: regStakeholderMaster?.panNumber,
        bankAccountNumber: regStakeholderMaster?.bankAccountNumber,
        bankAccountHolderName: regStakeholderMaster?.bankAccountHolderName,
        bankBranch: regStakeholderMaster?.bankBranch,
        bankIfscCode: regStakeholderMaster?.bankIfscCode,
        bankName: regStakeholderMaster?.bankName,
        growerDocuments: growerDetails?.growers[0]?.growerDocuments,
        plotAddress: growerDetails?.growers[0]?.plotAddress,
        plotPincode: growerDetails?.growers[0]?.plotPincode,
        plotState: growerDetails?.growers[0]?.plotState,
        plotDistrict: growerDetails?.growers[0]?.plotDistrict,
        plotSubDivision: growerDetails?.growers[0]?.plotSubDivision,
        plotRevenueCircle: growerDetails?.growers[0]?.plotRevenueCircle,
        plotBlockName: growerDetails?.growers[0]?.plotBlockName,
        plotPostOffice: growerDetails?.growers[0]?.plotPostOffice,
        plotTotalLandArea: growerDetails?.growers[0]?.plotTotalLandArea,
        plotTotalNoOfBambooClumps: growerDetails?.growers[0]?.plotTotalNoOfBambooClumps,
        growerType: growerDetails?.growers[0]?.growerType,
        isOtpValidated: regStakeholderMaster.isOtpValidated,
        cooperativeName: growerDetails?.growers[0]?.cooperativeName,
        stakeHolderSubCategory: growerDetails?.growers[0]?.growerType,
        agreementStartDate: growerDetails?.growers[0]?.agreementStartDate,
        agreementEndDate: growerDetails?.growers[0]?.agreementEndDate,
        registrationCompleted: growerDetails?.growers[0]?.registrationCompleted,
        isMSME: regStakeholderMaster?.isMSME,
        msmeCategory: regStakeholderMaster?.msmeCategory,
      });
      const spaceIndex = growerDetails?.growers[0]?.plotTotalLandArea?.indexOf(" ");
      const numberPart = growerDetails?.growers[0]?.plotTotalLandArea?.slice(0, spaceIndex);
      const unitPart = growerDetails?.growers[0]?.plotTotalLandArea?.slice(spaceIndex + 1);
      setLandAreaValue(numberPart);
      setLandAreaUnit(unitPart);
      setMobileOTPValidated(regStakeholderMaster.isOtpValidated);
      setAgreementStartDateDisplay(growerDetails?.growers[0]?.agreementStartDate && moment(growerDetails?.growers[0]?.agreementStartDate).format(BASIC_DATE_FORMAT))
      setAgreementEndDateDisplay(growerDetails?.growers[0]?.agreementEndDate && moment(growerDetails?.growers[0]?.agreementEndDate).format(BASIC_DATE_FORMAT))
    }

  }, [growerDetails]);
  const getUpdatedAddressData = (data) => {
    setPersonalUpdatedDetails({
      ...personalUpdatedDetails,
      pincode: data.pincode,
      state: data.pincodeState,
      district: data.pincodeDistrict,
      subDivision: data.pincodeSubDivision,
      revenueCircle: data.selectedRevenueCircle,
      blockName: data.selectedBlockName,

    })
  }
  const onUploadCallBack = (docArray) => {

    setPersonalUpdatedDetails({ ...personalUpdatedDetails, growerDocuments: docArray });
  }
  const getBambooUpdatedAddressData = (data) => {
  }
  useEffect(() => {
    if (bankDetails) {
      setPersonalUpdatedDetails({
        ...personalUpdatedDetails, bankBranch: bankDetails?.branch, bankName: bankDetails?.bank
      });
    }
  }, [bankDetails]);

  const commentsColumn = [
    {
      field: 'comment', headerName: t('reg.comments'), width: 330,
      renderCell: (params) => {
        return (
          <div style={{ wordBreak: "break-all", overflowWrap: "break-word", whiteSpace: "normal", minHeight: "auto" }}>
            {params.value.split('<br />').map((line, index) => (
              <>
                {line}
                <br />
              </>
            ))}
          </div>
        )
      }
    },
    {
      field: 'createdByName', headerName: t('preReg.name'), width: 200
    },
    {
      field: 'userRole', headerName: t('reg.userRole'), width: 200
    },
    {
      field: 'createdOnFormatted', headerName: t('reg.date'), width: 200,
    },
  ]

  const onSaveComment = (comment, sectionName, sectionOk) => {
    const commentObject = {
      comment: comment,
      stakeholderMasterId: growerDetails?.growers[0]?.regStakeholderMasterId,
      sectionName: sectionName,
      sectionId: growerDetails?.growers[0]?.id,
      sectionOk: sectionOk,
      userRole: localStorage.getItem('role'),
      createdBy: decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid,
    }
    comment ? insertComment([commentObject], growerDetails?.growers[0]?.regStakeholderMasterId, setCommentsData) : toast.error("Please enter comment")
    setPersonalComment("");
    setBankComment("");
    // setBambooComment("");
    setAgreementComment("");
    setErrorMessage({ ...errorMessage, personalCommentError: "", bankCommentError: "", agreementCommentError: "" });
  }

  function getBankDetails() {
    apiClient
      .post(GET_ADDRESS_BY_IFSC,
        {
          "ifsc": personalUpdatedDetails?.bankIfscCode,
        },
        {
          headers: {
            AuthKey: authKey,
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          setBankDetails(response.data);
          setErrorMessage({ ...errorMessage, ifscCodeError: "" });
        }
        else {
          setPersonalUpdatedDetails({
            ...personalUpdatedDetails,
            bankIfscCode: "",
            bankBranch: '',
          })
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  }
  const handleDateChange = (e, name) => {
    // e.preventDefault();
    let date = e.format("YYYY-MM-DD");
    let formattedDate = moment(date).format(API_DATE_FORMAT)
    setPersonalUpdatedDetails({ ...personalUpdatedDetails, [name]: formattedDate })
    if (name == "agreementStartDate")
      setAgreementStartDateDisplay(date);
    else if (name == "agreementEndDate")
      setAgreementEndDateDisplay(date);
  }
  const handleChange = (e) => {
    setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value });
    if (e.target.name === "fullName") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0 && VALIDATION.fullNameValidation(e.target.value)) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value.slice(0, maxNameLength)) })
        setErrorMessage({ ...errorMessage, nameError: '' })
      } else setErrorMessage({ ...errorMessage, nameError: "Please Enter Valid Name" })
    }
    if (e.target.name === "contactPersonFirstname") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0 && nameValidation(e.target.value)) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
        setErrorMessage({ ...errorMessage, contactPersonFirstNameError: '' })
      } else setErrorMessage({ ...errorMessage, contactPersonFirstNameError: "Please Enter Valid Name" })
    }
    if (e.target.name === "contactPersonMiddlename") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      } else return
    }
    else if (e.target.name === "contactPersonLastname") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      if ((e.target.value).length > 0) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: nameValidation(e.target.value.slice(0, maxNameLength)) })
      } else return
    }
    else if (e.target.name === 'emailId') {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.slice(0, 50) })
      if ((e.target.value).length > 0) {
        if (emailValidation(e.target.value.slice(0, 50))) {
          setErrorMessage({ ...errorMessage, emailIdError: "" })
        } else setErrorMessage({ ...errorMessage, emailIdError: "Please enter valid Email Address" })
      }
      else setErrorMessage({ ...errorMessage, emailIdError: "" })
    }
    else if (e.target.name === "address") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200)) });
      if ((e.target.value).length > 0 && VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 200))) {
        setErrorMessage({ ...errorMessage, addressError: " " })
      } else {
        setErrorMessage({ ...errorMessage, addressError: "Please enter address" })

      }
    }
    else if (e.target.name === "bankAccountNumber") {
      const limit = 18;
      if (e.target.value.length > 0 && VALIDATION.bankAccountNumberValidation(e.target.value.slice(0, limit))) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.slice(0, limit) })
        setErrorMessage({ ...errorMessage, accountNumberError: '' })

      } else setErrorMessage({ ...errorMessage, accountNumberError: 'Please enter valid Account Number' })
    }
    else if (e.target.name === "bankAccountHolderName") {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.bankAccountNameValidation(e.target.value) })
      if (e.target.value.length > 0 && VALIDATION.bankAccountNameValidation(e.target.value)) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.bankAccountNameValidation(e.target.value) })
        setErrorMessage({ ...errorMessage, accountHolderNameError: '' })
      } else setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })
    }
    else if (e.target.name === 'otherGovtCardType') {
      const limit = 50;
      if (e.target.value.length > 0) {
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: VALIDATION.fullNameValidation(e.target.value).slice(0, limit) });
        setErrorMessage({ ...errorMessage, otherCardError: '' })
      }
      else {
        setErrorMessage({ ...errorMessage, otherCardError: 'Please enter ID Proof Name' })
      }
    }

    // else if (e.target.name === "bankIfscCode") {
    //   setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: (e.target.value) })
    //   if (e.target.value.length > 0) {
    //     setErrorMessage({ ...errorMessage, ifscCodeError: '' })
    //   } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter IFSC code" })
    // }
    if (e.target.name === 'panNumber') {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.replace(/[^a-zA-Z0-9]/gi, '') });
      if (e.target.value.length > 0 && VALIDATION.panNumberValidation(e.target.value)) {
        setErrorMessage({ ...errorMessage, panNumberError: "" })
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value });
      } else setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
    }
    if (e.target.name === 'bankIfscCode') {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value.replace(/[^a-zA-Z0-9]/gi, '') });
      if (e.target.value.length > 0 && VALIDATION.ifscValidation(e.target.value)) {
        setErrorMessage({ ...errorMessage, ifscCodeError: " " })
        setPersonalUpdatedDetails({ ...personalUpdatedDetails, [e.target.name]: e.target.value, bankBranch: "" });
      } else setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC Code" })
    }
    if (e.target.name === "landAreaValue") {
      var slicedLandArea = landAreaValidation(e.target.value);
      setLandAreaValue(slicedLandArea);
      if (slicedLandArea.length == 0) {
        setErrorMessage({ ...errorMessage, plotTotalLandAreaError: LAND_AREA_ERROR });
      }
      else setErrorMessage({ ...errorMessage, plotTotalLandAreaError: "" });
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, "plotTotalLandArea": slicedLandArea + ' ' + landAreaUnit });
    }
    if (e.target.name === "landAreaUnit") {
      setLandAreaUnit(e.target.value);
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, "plotTotalLandArea": landAreaValue + ' ' + e.target.value });
    }

  };
  const checkValidations = (e) => {
    var idProof = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "MOA_RegistrationCertificate" && item.isActive == 1);
    var bankdoc = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "BankPassBook_CancelledCheque" && item.isActive == 1);
    if (!personalUpdatedDetails.address || personalUpdatedDetails.address.length == 0) {
      setErrorMessage({ ...errorMessage, addressError: "Please enter address" })
      return;
    }
    else if (personalUpdatedDetails.pincode && personalUpdatedDetails.pincode.length !== 6) {
      setErrorMessage({ ...errorMessage, pincodeError: "Please enter a valid pincode" })
      return;
    }
    else if (!personalUpdatedDetails.state || personalUpdatedDetails.state.length == 0) {
      setErrorMessage({ ...errorMessage, searchError: "Please search pincode" })
      return;
    }
    else if (userRole !== ROLES.ItAdmin && (!personalUpdatedDetails.govtIdCardNumber || personalUpdatedDetails.govtIdCardNumber.length == 0)) {
      setErrorMessage({ ...errorMessage, govtIdCardNumberError: "Please enter ID Number" })
      return;
    }

    else if (idProof.length == 0) {
      setErrorMessage({ ...errorMessage, govtIdCardNumberError: '', idProofDocError: "Please upload ID Proof document" });
      return;
    }
    else if (!personalUpdatedDetails.bankAccountNumber || personalUpdatedDetails.bankAccountNumber.length == 0 || !VALIDATION.bankAccountNumberValidation(personalUpdatedDetails.bankAccountNumber)) {
      setErrorMessage({ ...errorMessage, idProofDocError: '', accountNumberError: "Please enter valid Account Number" })
      return;
    }
    else if (!personalUpdatedDetails.bankAccountHolderName || personalUpdatedDetails.bankAccountHolderName.length == 0 || !VALIDATION.bankAccountNameValidation(personalUpdatedDetails.bankAccountHolderName)) {
      setErrorMessage({ ...errorMessage, accountHolderNameError: "Please enter Account Holder's Name" })
      return;
    }
    else if (!personalUpdatedDetails.bankIfscCode || personalUpdatedDetails.bankIfscCode.length == 0 || !VALIDATION.ifscValidation(personalUpdatedDetails.bankIfscCode)) {
      setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC code" })
      return;
    }
    else if (!personalUpdatedDetails.bankBranch || personalUpdatedDetails.bankBranch.length == 0) {
      setErrorMessage({ ...errorMessage, ifscCodeError: "Please enter valid IFSC code and search" })
      return;
    }
    else if (bankdoc.length == 0) {
      setErrorMessage({ ...errorMessage, bankDocError: "Please upload bank document" });
      return;

    }
    else if (!personalUpdatedDetails.agreementStartDate || personalUpdatedDetails.agreementStartDate.length == 0) {
      setErrorMessage({ ...errorMessage, bankDocError: '', agreementStartDateError: "Please enter agreement start date" })
      return;
    }
    else if (!personalUpdatedDetails.agreementEndDate || personalUpdatedDetails.agreementEndDate.length == 0) {
      setErrorMessage({ ...errorMessage, agreementStartDateError: '', agreementEndDateError: "Please enter agreement end date" })
      return;
    }
    else if (personalUpdatedDetails.agreementStartDate >= personalUpdatedDetails.agreementEndDate) {
      setErrorMessage({ ...errorMessage, agreementEndDateError: "agreement end date can not be less than agreement start date" })
      return;
    }
    else if (personalUpdatedDetails.panNumber && personalUpdatedDetails.panNumber.length > 0 && !VALIDATION.panNumberValidation(personalUpdatedDetails.panNumber)) {
      setErrorMessage({ ...errorMessage, panNumberError: "Please enter valid PAN Number" })
      return;
    }
    var agreement = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "LOI_ABRPLAgreement" && item.isActive == 1);
    if (agreement.length == 0) {
      setErrorMessage({ ...errorMessage, agreementEndDateError: '', agreementDocError: "Please upload LOI and agreement document" });
      return;
    }
    var harvest = personalUpdatedDetails?.growerDocuments && personalUpdatedDetails?.growerDocuments.filter((item) => item.documentType === "Harvest_Plan" && item.isActive == 1);
    if (harvest.length == 0) {
      setErrorMessage({ ...errorMessage, agreementDocError: '', harvestPlanDocError: "Please upload harvesting plan document" });
      return;
    }
    if (showCommentSection &&
      (shouldActOnSection.personal_details && !comments.find((item) => item.sectionName === "personal_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null)
        || (shouldActOnSection.bank_details && !comments.find((item) => item.sectionName === "bank_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null))
        || (shouldActOnSection.agreement_details && !comments.find((item) => item.sectionName === "agreement_details" && item.createdBy === (decoded.extension_URN ? growerDetails?.growers[0]?.regStakeholderMasterId : uuid) && item.workflowStepDetailsId === null))
      )) {
      toast.error("Please enter comments for required sections");
      return
    }
    updatePersonalCallback(personalUpdatedDetails, growerDetails?.growers[0]?.growerType === 'JFMC' ? "forestJfmc" : 'landsList', "next")
  }
  const onClickVerifyMobileNo = (e) => {
    e.preventDefault();
    setErrorMessage({ ...errorMessage, OTPError: "" });
    setOtpValue("");
    if (personalUpdatedDetails.mobileNo) {
      sendOTP(personalUpdatedDetails.mobileNo, callBackMobileValidation);
    }
  }
  const callBackMobileValidation = (response) => {
    if (response.isSuccess) {
      setVerifyMobileNo(true);
      setOtpHidden(false);
      setErrorMessage({ ...errorMessage, OTPError: "" });
    }
  }
  const onOtpChange = (e) => {
    const limit = 6;
    setOtpValue(e.target.value.slice(0, limit))
    if (e.target.value.length == 6) {
      validateOTP(personalUpdatedDetails.mobileNo, e.target.value, callBackOTPValidation);
    }
  }
  const callBackOTPValidation = (response) => {
    if (response.isSuccess) {
      setVerifyMobileNo(false);
      setOtpHidden(true);
      setMobileOTPValidated(true);
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, isOtpValidated: true })
      setErrorMessage({ ...errorMessage, OTPError: "" });
    }
    else {
      setErrorMessage({ ...errorMessage, OTPError: INVALID_OTP_ERROR });
    }
  }
  const handleChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, blockName: e.target.value });
    }
    if (type == REVENUE_CIRCLE) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, revenueCircle: e.target.value, });
    }
  }
  const handleBambooChangeSelect = (e, type) => {
    if (type == BLOCK_LIST) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, plotBlockName: e.target.value });
    }
    if (type == REVENUE_CIRCLE) {
      setPersonalUpdatedDetails({ ...personalUpdatedDetails, plotRevenueCircle: e.target.value, });
    }
  }

  return (
    <> {personalUpdatedDetails && <>
      <Grid item xs={12}>
        <Accordion mt={1}
          expanded={expandedSection === "personal"}
          onChange={(event, expanded) => {
            setExpandedSection(expanded ? "personal" : "");
          }}
        >
          <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
          >
            <Stack ml={2} direction="row">
              {showCommentSection && !regScruResourceUpdate && (personalDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
              {/* <Typography variant="subtitle1"> {t('preReg.personalDetails')}</Typography> */}
              <Typography variant="subtitle1">{t('preReg.organizationDetails')}</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container pr={4} pb={3} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (personalDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "103.5%" }}>
              <Grid item xs={12}>
                <TextField fullWidth
                  required
                  error={errorMessage.nameError}
                  helperText={errorMessage.nameError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  type="text"
                  name="fullName"
                  label={i18n.resolvedLanguage === 'as' ? personalUpdatedDetails?.stakeHolderSubCategory + " " + t('preReg.name') : t('preReg.name') + " " + personalUpdatedDetails?.stakeHolderSubCategory}
                  value={personalUpdatedDetails.fullName || ''}
                  onChange={(e) => handleChange(e)}

                />
                <BadgeComponent currentLength={personalUpdatedDetails?.fullName?.length} maxLength={maxNameLength} />
              </Grid>
              <Grid item xs={12} lg={2}>
                <FormControl>
                  <FormLabel
                    sx={{
                      fontWeight: 600,
                      fontSize: '1rem',
                      color: 'text.primary',
                    }}
                  >Is MSME?</FormLabel>

                  <ToggleButtonGroup
                    value={isMSMERadio}
                    exclusive
                    onChange={(e, value) => value && setIsMSMERadio(value)}
                    disabled={
                      !enableFieldFunction(shouldActOnSection.personal_details, false) ||
                      viewOnly
                    }
                    sx={{ mt: 1 }}
                  >
                    <ToggleButton value="YES">Yes</ToggleButton>
                    <ToggleButton value="NO">No</ToggleButton>
                  </ToggleButtonGroup>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={4} mt={3}>
                <FormControl fullWidth disabled={isMSMERadio !== 'YES'}>
                  <InputLabel>MSME Category</InputLabel>
                  <Select
                    label="MSME Category"
                    name="msmeCategory"
                    value={personalUpdatedDetails.msmeCategory || ''}
                    onChange={(e) =>
                      setPersonalUpdatedDetails({
                        ...personalUpdatedDetails,
                        msmeCategory: e.target.value
                      })
                    }
                    disabled={
                      !enableFieldFunction(shouldActOnSection.personal_details, false) ||
                      viewOnly
                    }
                  >
                    {MSME_CATEGORY_OPTIONS.map(option => (
                      <MenuItem key={option.key} value={option.key}>
                        <strong>{option.key}</strong> — {option.description}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
               <Grid item xs={12} lg={6} mt={2}>
              {isMSMERadio === 'YES' && (
               
                  <FileUploadMUI
                    key="MSME_Certificate"
                    disabled={
                      !enableFieldFunction(shouldActOnSection.personal_details, false) ||
                      viewOnly
                    }
                    documentList={personalUpdatedDetails?.growerDocuments}
                    documentType="MSME_Certificate"
                    callBackDocumentUpload={onUploadCallBack}
                    stakeholderDetailId={growerDetails?.growers[0]?.id}
                    title="Upload MSME Certificate"
                    stakeHolderType="grower"
                    errorMessage={errorMessage}
                    setErrorMessage={setErrorMessage}
                    documentError="msmeDocError"
                  />
                    )}
                </Grid>
            
              <Grid item xs={4} lg={2}>
                <FormControl fullWidth>
                  <InputLabel>{t('preReg.salutation')}</InputLabel>
                  <Select
                    label={t('preReg.salutation')}
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    name='contactPersonSalutation'
                    onChange={(e) => handleChange(e)}
                    value={personalUpdatedDetails.contactPersonSalutation}>
                    {SALUTATION.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={8} lg={4}>
                <TextField fullWidth
                  required
                  error={errorMessage.contactPersonFirstNameError}
                  helperText={errorMessage.contactPersonFirstNameError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  type="text"
                  name="contactPersonFirstname"
                  label={t('preReg.firstname')}
                  value={personalUpdatedDetails.contactPersonFirstname}
                  onChange={(e) => handleChange(e)}

                />
                <BadgeComponent currentLength={personalUpdatedDetails?.contactPersonFirstname?.length} maxLength={maxNameLength} />
              </Grid>
              <Grid item xs={6} lg={3}>
                <TextField fullWidth
                  required
                  error={errorMessage.contactPersonMiddlenameError}
                  helperText={errorMessage.contactPersonMiddlenameError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  type="text"
                  name="contactPersonMiddlename"
                  label={t('preReg.middlename')}
                  value={personalUpdatedDetails.contactPersonMiddlename}
                  onChange={(e) => handleChange(e)}

                />
                <BadgeComponent currentLength={personalUpdatedDetails?.contactPersonMiddlename?.length} maxLength={maxNameLength} />
              </Grid>
              <Grid item xs={6} lg={3}>
                <TextField fullWidth
                  required
                  error={errorMessage.contactPersonLastnameError}
                  helperText={errorMessage.contactPersonLastnameError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  type="text"
                  name="contactPersonLastname"
                  label={t('preReg.lastname')}
                  value={personalUpdatedDetails.contactPersonLastname}
                  onChange={(e) => handleChange(e)}

                />
                <BadgeComponent currentLength={personalUpdatedDetails?.contactPersonLastname?.length} maxLength={maxNameLength} />
              </Grid>
              <Grid item xs={4} lg={2}>
                <FormControl fullWidth>
                  <InputLabel>{t('preReg.gender')}</InputLabel>
                  <Select
                    required
                    label={t('preReg.gender')}
                    name='contactPersonGender'
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                    onChange={(e) => handleChange(e)}
                    value={personalUpdatedDetails.contactPersonGender}>
                    {GENDER.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                  </Select>
                  <FormHelperText sx={{ color: 'red' }}>{errorMessage.genderError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={!ResourceUpdateMember.includes(userRole) ? 8 : 4} lg={4}>
                <TextField fullWidth
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  type="text"
                  name="MobileNo"
                  label={t('preReg.mobileNo')}
                  value={personalUpdatedDetails.mobileNo}
                  onChange={(e) => handleChange(e)}
                  InputProps={{
                    maxLength: 10
                  }}
                />
                <BadgeComponent currentLength={personalUpdatedDetails?.mobileNo?.length} maxLength={mobileNoMaxLength} />
                {!ResourceUpdateMember.includes(userRole) ?
                  <>
                    {mobileOTPValidated ?
                      <div className="commonVerifyText"><a href="#">Verified</a>
                        <img className="commonOtpImg" src={resolveIcon} alt="" /></div>
                      :
                      <div hidden={mobileOTPValidated || verifyMobileNo} style={{ float: "right" }}><button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Verify Mobile No.</button>
                        <div className='errorText_storage'>{errorMessage.OTPError}</div>
                        <div hidden={otpHidden}><button className="commonVerifyText" onClick={(e) => onClickVerifyMobileNo(e)}>Resend OTP</button></div></div>

                    }
                  </> : null}
              </Grid>
              <Grid item xs={3} lg={2} hidden={otpHidden}>
                <TextField fullWidth
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  onChange={(e) => onOtpChange(e)}
                  value={otpValue}
                  label={t('preReg.otp')} />
              </Grid>
              <Grid item xs={12} lg={6}>
                <TextField fullWidth
                  error={errorMessage.emailIdError}
                  helperText={errorMessage.emailIdError}
                  type="text"
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                  label={t('main.email')}
                  name="emailId"
                  value={personalUpdatedDetails.emailId}
                  onChange={(e) => handleChange(e)} />
                <BadgeComponent currentLength={personalUpdatedDetails?.emailId?.length} maxLength={emailUrnPassMaxLength} />
              </Grid>
              <Grid item xs={12} lg={12}>
                <TextField fullWidth
                  required
                  error={errorMessage.addressError}
                  helperText={errorMessage.addressError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                  type="text"
                  multiline
                  name="address"
                  label={t('main.address')}
                  value={personalUpdatedDetails.address}

                  onChange={(e) => handleChange(e)}
                />
                <BadgeComponent currentLength={personalUpdatedDetails?.address?.length} maxLength={addressMaxLength} />
              </Grid>
              <CommonPincodeMUI setErrorMessage={setErrorMessage}
                fullWidth={true}
                isDisabled={!enableFieldFunction(shouldActOnSection.personal_details, true)}
                pincode={personalUpdatedDetails.pincode}
                state={personalUpdatedDetails.state}
                district={personalUpdatedDetails.district}
                revenueCircle={personalUpdatedDetails.revenueCircle}
                blockName={personalUpdatedDetails.blockName}
                onHandleCallback={getUpdatedAddressData}
                pincodeError={errorMessage.pincodeError}
                searchError={errorMessage.searchError}
                handleChangeSelect={handleChangeSelect}
              />
              <Grid item xs={12} lg={4}>
                <TextField fullWidth
                  required
                  error={errorMessage.panNumberError}
                  helperText={errorMessage.panNumberError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                  type="text"
                  label={t('reg.panNumber')}
                  InputProps={{
                    maxLength: 10,
                    style: { textTransform: "uppercase" }
                  }}
                  name="panNumber"
                  value={personalUpdatedDetails.panNumber || ''}
                  onChange={(e) => handleChange(e)} />
                <BadgeComponent currentLength={personalUpdatedDetails?.panNumber?.length} maxLength={govtIDcardLength} />
                <FileUploadMUI key="PANCard"
                  documentList={personalUpdatedDetails?.growerDocuments}
                  documentType="PANCard"
                  callBackDocumentUpload={onUploadCallBack}
                  stakeholderDetailId={growerDetails?.growers[0]?.id}
                  title={t('preReg.uploadPanDoc')}
                  stakeHolderType="grower"
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                  documentError="panDocError"
                />
                {/* <div className='mandatory_field'>{errorMessage.panDocError}</div> */}
              </Grid>

              <Grid item xs={6} lg={4}>
                <FormControl fullWidth>
                  <InputLabel>{t('preReg.idProof')}</InputLabel>
                  <Select
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    label={t('preReg.idProof')}
                    name="govtIdCardType"
                    value={personalUpdatedDetails.govtIdCardType}
                    onChange={(e) => handleChange(e)}>
                    <MenuItem disabled value="">Certificate Type</MenuItem>
                    {CONSTANTS.ID_PROOF_ARRAY.map((item) => <MenuItem value={item}>{item}</MenuItem>)}
                  </Select>
                </FormControl>
              </Grid>
              {personalUpdatedDetails.govtIdCardType === "Other" &&
                <Grid item xs={6} lg={4}>
                  <TextField fullWidth
                    disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                    type="text"
                    label={t('preReg.enterIdProof')}
                    name="otherGovtCardType"

                    value={personalUpdatedDetails.otherGovtCardType}
                    onChange={(e) => handleChange(e)} />
                </Grid>
              }
              <Grid item xs={personalUpdatedDetails.govtIdCardType === "Other" ? 12 : 6} lg={4}>
                <TextField fullWidth
                  required
                  error={errorMessage.govtIdCardNumberError}
                  helperText={errorMessage.govtIdCardNumberError}
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                  type="text"
                  label={personalUpdatedDetails.govtIdCardType === "MOA" ? t('preReg.enterMOA') : personalUpdatedDetails.govtIdCardType === "Registration Certificate" ? t('preReg.enterRegNo') : personalUpdatedDetails.govtIdCardType === "GST" ? t('preReg.enterGSTNo') : t('preReg.enterNo')}
                  name="govtIdCardNumber"
                  value={personalUpdatedDetails.govtIdCardNumber}
                  InputProps={{
                    style: { textTransform: "uppercase" }
                  }}
                  onChange={(e) => handleChange(e)} />
                <BadgeComponent currentLength={personalUpdatedDetails?.govtIdCardNumber?.length} maxLength={govtIDcardLength} />
                <FileUploadMUI key="MOA_RegistrationCertificate"
                  documentList={personalUpdatedDetails?.growerDocuments}
                  documentType="MOA_RegistrationCertificate"
                  callBackDocumentUpload={onUploadCallBack}
                  stakeholderDetailId={growerDetails?.growers[0]?.id}
                  title={t('reg.uploadIDProofDoc')}
                  stakeHolderType="grower"
                  disabled={!enableFieldFunction(shouldActOnSection.personal_details, false)}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                  documentError="idProofDocError"
                />
                {/* <div className='mandatory_field'>{errorMessage.idProofDocError}</div> */}
              </Grid>
            </Grid>
            {showCommentSection && <>
              <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                <Grid item xs={8}>
                  <TextField sx={{ width: "100%" }}
                    label={t('reg.comment')}
                    name="comment"
                    inputProps={{
                      maxLength: 300,
                    }}
                    multiline
                    disabled={!shouldActOnSection.personal_details || viewOnly}
                    value={personalComment}
                    onChange={(e) => setPersonalComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                  />
                  <BadgeComponent currentLength={personalComment?.length} maxLength={approverCommentMaxLength} />
                  {/* <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${personalComment?.length > characterLimit ? 'danger' : 'primary'}`}>{personalComment?.length}/{characterLimit}</Badge>
                  </div> */}
                </Grid>
                <Grid item xs={2}>
                  <FormGroup>
                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.personal_details || viewOnly} checked={personalDetailsSectionOk}
                      onChange={(e) => setPersonalDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2" gutterBottom>
                        {t('reg.detailsOk')}?
                      </Typography>} />
                  </FormGroup>
                </Grid>
                <Grid xs={2}>
                  <Button variant="contained" disabled={!shouldActOnSection.personal_details || viewOnly}
                    onClick={() => onSaveComment(personalComment, "personal_details", personalDetailsSectionOk)}
                    startIcon={<CommentIcon />}
                  >
                    {t('preReg.addComment')}
                  </Button>
                </Grid>
              </Grid>
              <div>
                <Accordion mt={1}>
                  <AccordionSummary
                    expandIcon={<AccordionIcon />}
                  >
                    <Typography variant="subtitle1" >{t('reg.commentHistory')}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box style={{ height: 300, width: '100%' }}>
                      <DataGrid
                        rows={personalComments ? personalComments : []}
                        columns={commentsColumn}
                        pageSize={10}
                        getRowHeight={() => 'auto'} />
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </div></>}
          </AccordionDetails>

        </Accordion>
      </Grid>
      <Grid item xs={12}>
        <Accordion mt={1} expanded={expandedSection === "bank"}
          onChange={(event, expanded) => {
            setExpandedSection(expanded ? "bank" : "");
          }}>
          <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
          >
            <Stack ml={2} direction="row">
              {showCommentSection && !regScruResourceUpdate && (bankDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
              <Typography variant="subtitle1" > {t('preReg.bankDetails')}</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container pb={3} pr={4} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (bankDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "105%" }}>
              <Grid item xs={12} lg={4}>
                <TextField fullWidth
                  required
                  error={errorMessage.accountNumberError}
                  helperText={errorMessage.accountNumberError}
                  disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  name="bankAccountNumber"
                  label={t('preReg.accountNo')}
                  value={personalUpdatedDetails.bankAccountNumber || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '.' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField fullWidth
                  required
                  error={errorMessage.accountHolderNameError}
                  helperText={errorMessage.accountHolderNameError}
                  disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                  type="text"
                  name="bankAccountHolderName"
                  label={t('preReg.accountHolderName')}
                  value={personalUpdatedDetails.bankAccountHolderName || ''}
                  onChange={(e) => handleChange(e)}
                  InputProps={{
                    maxLength: maxNameLength,
                    style: { textTransform: "uppercase" }
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={4}>
                <TextField fullWidth
                  required
                  error={errorMessage.ifscCodeError}
                  helperText={errorMessage.ifscCodeError}
                  type="text"
                  disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                  name="bankIfscCode"
                  label={t('preReg.ifscCode')}
                  value={personalUpdatedDetails.bankIfscCode || ''}
                  onChange={(e) => handleChange(e)}
                  onKeyDown={(evt) => (evt.key === '.' || evt.key === '-') && evt.preventDefault()}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        {(!ResourceUpdateMember.includes(userRole) || userRole === ROLES.ItAdmin) ? <IconButton color="primary" aria-label="search" onClick={() => getBankDetails()} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} >
                          <SearchIcon />
                        </IconButton> : <IconButton color="primary" aria-label="search" onClick={() => getBankDetails()} disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)} >
                        </IconButton>}
                      </InputAdornment>
                    ),
                    maxLength: 11, style: { textTransform: "uppercase" }
                  }}
                ></TextField>
              </Grid>
              <Grid item xs={12} lg={5}>
                <TextField fullWidth
                  type="text"
                  name="bankBranch"
                  label={t('preReg.branch')}
                  value={personalUpdatedDetails.bankBranch || ''}
                  onChange={(e) => handleChange(e)}
                  disabled
                />
                <FileUploadMUI key="BankPassBook_CancelledCheque"
                  documentList={personalUpdatedDetails?.growerDocuments}
                  documentType="BankPassBook_CancelledCheque"
                  callBackDocumentUpload={onUploadCallBack}
                  stakeholderDetailId={growerDetails?.growers[0]?.id}
                  title={t('preReg.uploadPassbookCancelledCheck')}
                  stakeHolderType="grower"
                  disabled={!enableFieldFunction(shouldActOnSection.bank_details, false)}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                  documentError="bankDocError"
                />
                {/* <div className='mandatory_field'>{errorMessage.bankDocError}</div> */}
              </Grid>
            </Grid>
            {showCommentSection && <>
              <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                <Grid item xs={8}>
                  <TextField sx={{ width: "100%" }}
                    label={t('reg.comment')}
                    name="comment"
                    inputProps={{
                      maxLength: 300,
                    }}
                    multiline
                    disabled={!shouldActOnSection.bank_details || viewOnly}
                    value={bankComment}
                    onChange={(e) => setBankComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${bankComment?.length > characterLimit ? 'danger' : 'primary'}`}>{bankComment?.length}/{characterLimit}</Badge>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <FormGroup>
                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.bank_details || viewOnly} checked={bankDetailsSectionOk}
                      onChange={(e) => setBankDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2" gutterBottom>
                        {t('reg.detailsOk')}?
                      </Typography>} />
                  </FormGroup>
                </Grid>
                <Grid xs={2}>
                  <Button variant="contained"
                    disabled={!shouldActOnSection.bank_details || viewOnly}
                    onClick={() => onSaveComment(bankComment, "bank_details", bankDetailsSectionOk)}
                    startIcon={<CommentIcon />}
                  >
                    {t('preReg.addComment')}
                  </Button>
                </Grid>
              </Grid>
              <div>
                <Accordion mt={1}>
                  <AccordionSummary
                    expandIcon={<AccordionIcon />}
                  >
                    <Typography variant="subtitle1" >{t('reg.commentHistory')}</Typography>
                  </AccordionSummary>
                  <AccordionDetails><Box style={{ height: 300, width: '100%' }}>
                    <DataGrid
                      rows={bankComments ? bankComments : []}
                      columns={commentsColumn}
                      pageSize={10}
                      getRowHeight={() => 'auto'} />
                  </Box>
                  </AccordionDetails>
                </Accordion>
              </div></>}
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid item xs={12}>
        <Accordion mt={1} expanded={expandedSection === "agreement"}
          onChange={(event, expanded) => {
            setExpandedSection(expanded ? "agreement" : "");
          }}>
          <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF" }}
            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
          >
            <Stack ml={2} direction="row">
              {showCommentSection && !regScruResourceUpdate && !regScruResourceUpdate && (agreementDetailsSectionOk ? <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} /> : <CrossIcon sx={{ fontSize: 20, color: "#f44336", marginRight: "1vh" }} />)}
              <Typography variant="subtitle1"> {t('preReg.agreementDetails')}</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container pb={3} pr={4} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? (agreementDetailsSectionOk ? "#E9FBF0" : "#FFEBEE") : "FFFFFF", width: "105%" }}>
              <Grid item xs={6} lg={6}>
                <FormControl fullWidth >
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      label={t('preReg.agreementStartDate')}
                      inputFormat="DD/MM/YYYY"
                      value={agreementStartDateDisplay}
                      name="agreementStartDate"
                      onChange={(e) => handleDateChange(e, "agreementStartDate")}
                      disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                      renderInput={(params) => <TextField {...params} />}
                      sx={{ minWidth: 750 }}
                    />
                  </LocalizationProvider>
                  <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementStartDateError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={6} lg={6}>
                <FormControl fullWidth>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DesktopDatePicker
                      inputFormat="DD/MM/YYYY"
                      minDate={agreementStartDateDisplay}
                      value={agreementEndDateDisplay}
                      label={t('preReg.agreementEndDate')}
                      name="agreementEndDate"
                      onChange={(e) => handleDateChange(e, "agreementEndDate")}
                      disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                      renderInput={(params) => <TextField {...params} />}
                      sx={{ minWidth: 750 }}
                    />
                  </LocalizationProvider>
                  <FormHelperText sx={{ color: 'red' }}>{errorMessage.agreementEndDateError}</FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} lg={6}>
                <FileUploadMUI key="LOI_ABRPLAgreement"
                  documentList={personalUpdatedDetails?.growerDocuments}
                  documentType="LOI_ABRPLAgreement"
                  callBackDocumentUpload={onUploadCallBack}
                  stakeholderDetailId={growerDetails?.growers[0]?.id}
                  title={t('reg.uploadLOI&AgreementDoc')}
                  stakeHolderType="grower"
                  disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                  documentError="agreementDocError"
                />
                {/* <div className='mandatory_field'>{errorMessage.agreementDocError}</div> */}
              </Grid>
              <Grid item xs={12} lg={6}>
                <FileUploadMUI key="Harvest_Plan"
                  documentList={personalUpdatedDetails?.growerDocuments}
                  documentType="Harvest_Plan"
                  callBackDocumentUpload={onUploadCallBack}
                  stakeholderDetailId={growerDetails?.growers[0]?.id}
                  title={t('reg.uploadHarvestingPlanDoc')}
                  stakeHolderType="grower"
                  disabled={!enableFieldFunction(shouldActOnSection.agreement_details, false)}
                  errorMessage={errorMessage}
                  setErrorMessage={setErrorMessage}
                  documentError="harvestPlanDocError"
                />
                {/* <div className='mandatory_field'>{errorMessage.harvestPlanDocError}</div> */}
              </Grid>
            </Grid>
            {showCommentSection && <>
              <Grid container direction="row" mt={2} mb={2} alignItems="center" spacing={2}>
                <Grid item xs={8}>
                  <TextField sx={{ width: "100%" }}
                    label={t('reg.comment')}
                    name="comment"
                    inputProps={{
                      maxLength: 300,
                    }}
                    multiline
                    value={agreementComment}
                    disabled={!shouldActOnSection.agreement_details || viewOnly}
                    onChange={(e) => setAgreementComment(VALIDATION.noSpecialCharacterValidation(e.target.value))}
                  />
                  <div style={{ display: 'flex', justifyContent: 'flex-end', paddingTop: '1vh' }}>
                    <Badge bg={`${agreementComment?.length > characterLimit ? 'danger' : 'primary'}`}>{agreementComment?.length}/{characterLimit}</Badge>
                  </div>
                </Grid>
                <Grid item xs={2}>
                  <FormGroup>
                    <FormControlLabel control={<Switch disabled={!shouldActOnSection.agreement_details || viewOnly} checked={agreementDetailsSectionOk}
                      onChange={(e) => setAgreementDetailsSectionOk(e.target.checked)} />} label={<Typography variant="subtitle2" gutterBottom>
                        {t('reg.detailsOk')}?
                      </Typography>} />
                  </FormGroup>
                </Grid>
                <Grid xs={2}>
                  <Button variant="contained" disabled={!shouldActOnSection.agreement_details || viewOnly}
                    onClick={() => onSaveComment(agreementComment, "agreement_details", agreementDetailsSectionOk)}
                    startIcon={<CommentIcon />}
                  >
                    {t('preReg.addComment')}
                  </Button>
                </Grid>
              </Grid>
              <div>
                <Accordion mt={1}>
                  <AccordionSummary
                    expandIcon={<AccordionIcon />}
                  >
                    <Typography variant="subtitle1" >{t('reg.commentHistory')}</Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Box style={{ height: 300, width: '100%' }}>
                      <DataGrid
                        rows={agreementComments ? agreementComments : []}
                        columns={commentsColumn}
                        pageSize={10}
                        getRowHeight={() => 'auto'} />
                    </Box>
                  </AccordionDetails>
                </Accordion>
              </div></>}
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid item xs={12}>
        <Accordion mt={1} expanded={expandedSection === "bamboo"}
          onChange={(event, expanded) => {
            setExpandedSection(expanded ? "bamboo" : "");
          }}>
          <AccordionSummary sx={{ flexDirection: 'row-reverse', backgroundColor: showCommentSection && !regScruResourceUpdate ? "#E9FBF0" : "FFFFFF" }}
            expandIcon={<AccordionIcon sx={{ fontSize: '0.9rem' }} />}
          >
            <Stack ml={2} direction="row">
              {showCommentSection && !regScruResourceUpdate && <TickIcon sx={{ fontSize: 20, color: "#64dd17", marginRight: "1vh" }} />}
              <Typography variant="subtitle1" > {t('preReg.bambooDetails')}</Typography>
            </Stack>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container pb={3} pr={4} spacing={2} sx={{ backgroundColor: showCommentSection && !regScruResourceUpdate ? "#E9FBF0" : "FFFFFF", width: "105%" }}>
              <Grid item xs={12} lg={3}>
                <TextField fullWidth
                  disabled={!enableFieldFunction(false, true)}
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label={t('preReg.totalPlotArea')}
                  min="0"
                  name="landAreaValue"
                  value={landAreaValue}
                  onKeyDown={(evt) => typeNumberValid(evt)} onChange={(e) => handleChange(e)}
                  InputProps={{
                    endAdornment: (
                      <Select
                        variant="standard"
                        size="small"
                        disabled={!enableFieldFunction(false, true)}
                        value={landAreaUnit}
                        name="landAreaUnit"
                        onChange={(e) => handleChange(e)}>
                        {LAND_AREA_UNIT.map((item) => <MenuItem key={item} value={item}>{item}</MenuItem>)}
                      </Select>
                    ),
                  }}
                />
              </Grid>
              <Grid item xs={12} lg={3}>
                <TextField fullWidth
                  disabled={!enableFieldFunction(false, true)}
                  value={personalUpdatedDetails.plotTotalNoOfBambooClumps || ''} name="totalNumberOfClumps"
                  type="number"
                  onFocus={handleNumberFieldFocus}
                  label={t('preReg.totalClumps')}
                  onKeyDown={(evt) => typeNumberValid(evt)}
                  onChange={(e) => handleChange(e)} />
              </Grid>
              <Grid item xs={12} lg={6}>
                <TextField fullWidth
                  disabled={!enableFieldFunction(false, true)}
                  type="text"
                  label={t('preReg.plotAddress')}
                  multiline
                  name="plotAddress"
                  value={personalUpdatedDetails.plotAddress || ''}
                  InputProps={{
                    maxLength: 300,

                  }}
                  onChange={(e) => handleChange(e)} />
              </Grid>
              <CommonPincodeMUI setErrorMessage={setErrorMessage}
                fullWidth={true}
                pincode={personalUpdatedDetails.plotPincode}
                state={personalUpdatedDetails.plotState}
                district={personalUpdatedDetails.plotDistrict}
                revenueCircle={personalUpdatedDetails.plotRevenueCircle}
                blockName={personalUpdatedDetails.plotBlockName}
                isDisabled={!enableFieldFunction(false, true)}
                onHandleCallback={getBambooUpdatedAddressData}
                handleChangeSelect={handleBambooChangeSelect} />
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      {/* <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
          {!showWorkFlowButtons &&
            <Button
              sx={{ minWidth: 100 }}
              variant="contained"
              disabled={!enableSaveSubmitButtons || state?.viewOnly}
              onClick={() => updatePersonalCallback(personalUpdatedDetails, "personal", "save")} >{t('preReg.save')}</Button>}
          <Button
            sx={{ minWidth: 100, ml: 1 }}
            variant="contained"
            onClick={(e) => checkValidations(e)}>{t('preReg.next')}</Button>
        </Box> */}
    </>}</>
  );
};

export default JFMCGovtPersonalDetails;
